import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getProfile } from 'actions/profile';
import ProfileSidebar, { SECTIONS } from './ProfileSidebar';
import AccountOverview from './sections/AccountOverview';
import ManageAccount from './sections/ManageAccount';
import UpdateRoomPin from './sections/UpdateRoomPin';
import OwnedGames from './sections/OwnedGames';
import RedeemedCodes from './sections/RedeemedCodes';
import PurchaseHistory from './sections/PurchaseHistory';
import styles from './ProfileStyles.module.scss';

const Profile = () => {
    const { section } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [activeSection, setActiveSection] = useState(section || 'overview');

    // Load profile data on mount
    useEffect(() => {
        dispatch(getProfile());
    }, [dispatch]);

    // Update active section when URL changes
    useEffect(() => {
        if (section && SECTIONS.some(s => s.id === section)) {
            setActiveSection(section);
        } else if (section) {
            // Invalid section, redirect to overview
            navigate('/my-account', { replace: true });
        }
    }, [section, navigate]);

    const handleSectionChange = (sectionId) => {
        setActiveSection(sectionId);
        if (sectionId === 'overview') {
            navigate('/my-account');
        } else {
            navigate(`/my-account/${sectionId}`);
        }
    };

    const renderContent = () => {
        switch (activeSection) {
            case 'overview':
                return <AccountOverview onSectionChange={handleSectionChange} />;
            case 'account':
                return <ManageAccount />;
            case 'roompin':
                return <UpdateRoomPin />;
            case 'games':
                return <OwnedGames />;
            case 'codes':
                return <RedeemedCodes />;
            case 'purchases':
                return <PurchaseHistory />;
            default:
                return <AccountOverview />;
        }
    };

    return (
        <>
            <div className={styles.cloudBG}></div>
            <div className={styles.profilePage}>
                <div className={styles.profileContainer}>
                    <ProfileSidebar
                        activeSection={activeSection}
                        onSectionChange={handleSectionChange}
                    />
                    <main className={styles.content}>
                        <div className={styles.contentWrapper}>
                            {renderContent()}
                        </div>
                    </main>
                </div>
            </div>
            <div className={styles.cityScape}></div>
        </>
    );
};

export default Profile;
